var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('filters-button',[_c('button-component',{attrs:{"color":"dark","type":"half-right"},on:{"click":_vm.handleFiltersClick}},[_vm._v("\n      Anuluj\n    ")])],1),_vm._v(" "),_c('filters-header',{attrs:{"count":_vm.filtersCount},on:{"click":_vm.filter}}),_vm._v(" "),_c('filters-list',{attrs:{"available-filters":_vm.availableFilters,"filters":_vm.filters},on:{"toggleFilter":_vm.toggleFilter}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-610173f5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Settings/FiltersContainer.vue
// module id = null
// module chunks = 